import React from 'react';
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { Image } from "@project-stories/elements/Image/Image";

export default function Carousel({ settings, blocks }) {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const layoutType = isMobile
    ? settings.section.layout_mobile
    : settings.section.layout;
  const rows = settings.section.slide_rows > 0
    ? settings.section.slide_rows
    : (isMobile ? settings.section.rows_mobile : settings.section.rows);
  const gapBetweenBlocksX = isMobile
    ? settings.section.gap_x_mobile
    : settings.section.gap_x;
  const gapBetweenBlocksY = isMobile
    ? settings.section.gap_y_mobile
    : settings.section.gap_y;

  return (
    <div className={`expertise-${layoutType}`}>
      <div className={`expertise-info flex flex-col items-center text-center pr-3`}>
        <div className="expertise-info__wrapper flex flex-col gap-2 lg:gap-3">
          {settings.section.tagline && (
            <div className={`${isMobile ? settings.section.tagline_style_mobile : settings.section.tagline_style}`}>
              {settings.section.tagline}
            </div>
          )}
          <div className={`${isMobile ? settings.section.title_font_type_mobile : settings.section.title_font_type}`}>
            {settings.section.title}
          </div>
        </div>
        <div className="expertise-info__wrapper mt-6 flex flex-col gap-3">
          <div className={`expertise-info__subtitle ${isMobile ? settings.section.subtitle_style_mobile : settings.section.subtitle_style}`}>
            {settings.section.subtitle}
          </div>
          {settings.section.cta_text && (
            <div className={`${isMobile ? settings.section.cta_text_style_mobile : settings.section.cta_text_style}`}>
              {settings.section.cta_text}
            </div>
          )}
        </div>
      </div>
      <div className="expertise-carousel expertise-carousel-container mt-[60px]"
        data-flickity={`{` +
          `"freeScroll": ${settings.section.use_freescroll}, ` +
          `"wrapAround": true, ` +
          `"cellAlign": "left", ` +
          `"pageDots": ${settings.section.show_indicators}, ` +
          `"prevNextButtons": ${settings.section.show_navbuttons}, ` +
          `"groupCells": 1` +
          `}`}
        {...({
          "x-data": "carousel",
          "x-init": `$nextTick(() => { initialise(${settings.section.show_indicators}, ${settings.section.show_navbuttons}, ${settings.section.fade_edgeitems}, false, 0, 'expertise-carousel', true, ${settings.section.use_freescroll}) })`,
          "x-ref": "carousel",
        })}
      >
        {blocks.reduce((acc, block, index) => {
          if (index % rows === 0) {
            acc.push(blocks.slice(index, index + rows));
          }
          return acc;
        }, []).map((pair, index) => (
          <div
            key={index}
            className={`carousel-cell gap-y-[${gapBetweenBlocksY}px]`}
            style={{
              '--rows': rows,
              marginRight: `${gapBetweenBlocksX}px`,
              maxWidth: `${isMobile ? settings.section.visible_slide_width_mobile : 100}%`,
            }}
          >
            {pair.map((block) =>
              block && (
                <div key={block.key} className="tileitem-border p-6 w-full block-item">
                  <img src={block.settings.image_icon} alt={block.settings.title} />

                  <div className={`${isMobile ? block.settings.title_font_type_mobile : block.settings.title_font_type} mt-3`}>{block.settings.title}</div>
                  <div className={`${isMobile ? block.settings.content_font_style_mobile : block.settings.content_font_style} mt-2`}>{block.settings.content}</div>
                  {(() => {
                    const texts = Array.from({ length: 4 }, (_, i) => {
                      const key = `text_${i + 1}`;

                      return block.settings[key];
                    }).filter(Boolean);

                    return texts.length > 0 ? (
                      <div className="flex flex-wrap gap-2 mt-5">
                        {texts.map((value, idx) => (
                          <p
                            key={`text_${idx + 1}`}
                            className={`${isMobile ? block.settings.text_font_style_mobile : block.settings.text_font_style} px-3 py-2 rounded-full bg-[#D6CFF8]`}
                          >
                            {value}
                          </p>
                        ))}
                      </div>
                    ) : null;
                  })()}
                  {block.settings.cta_url && (
                    <a
                      href={block.settings.cta_url}
                      target={block.settings.is_open_in_new_tab ? "_blank" : "_self"}
                      className="link link-primary inline-block cursor-pointer py-3 pr-6 mt-5"
                    >
                      <span className="button__label">{block.settings.cta_text}</span>
                      <span className="icon-right-arrow-alt button__icon no-underline"></span>
                    </a>
                  )}
                </div>
              )
            )}
          </div>
        ))}

      </div>
    </div>
  )
}